import { combineReducers, Reducer } from "@reduxjs/toolkit";

import preferredTermsReducer from "./preferred-terms";
import rosterReducer from "./roster";
import serviceUsersReducer from "./service-users";
import staffReducer from "./staff";
import userReducer from "./user";

// Import other reducers as needed

const combinedReducer = combineReducers({
  user: userReducer,
  staff: staffReducer,
  serviceUsers: serviceUsersReducer,
  terms: preferredTermsReducer,
  roster: rosterReducer,
});

export type AppState = ReturnType<typeof combinedReducer>;

export const rootReducer: Reducer<AppState> = (state, action) => {
  if (action.type === "RESET") {
    localStorage.clear();
    state = {} as AppState;
  }
  if (action.type === "TENANT_SWITCH_RESET") {
    state = { user: state?.user } as AppState;
  }
  return combinedReducer(state, action);
};
